export const mergeSelectedMiscItems = <T extends { id?: string }>(
    items: T[],
    selected: T | T[] | null | undefined
): T[] => {
    if (!selected) {
        return items;
    }

    const selectedItems = Array.isArray(selected) ? selected : [selected];
    const merged = [...items];

    for (const selectedItem of selectedItems) {
        if (!selectedItem?.id) {
            continue;
        }

        if (merged.some(item => item.id === selectedItem.id)) {
            continue;
        }

        merged.push(selectedItem);
    }

    return merged;
};

export const mergeSelectedIdsIntoMiscItems = <T extends { id?: string }>(
    items: T[],
    selectedIds: Array<string | number> | null | undefined,
    allItems: T[] = []
): T[] => {
    const ids = (selectedIds ?? []).map(id => String(id));
    return mergeSelectedMiscItems(
        items,
        allItems.filter(item => item.id && ids.includes(item.id))
    );
};
